export default __webpack_public_path__ + "static/media/kioskLogo.ef308b36.svg";